import React from "react";
import { ValidationContainer } from "../validation-container";
import { ThemeProvider } from "react-jss";
import { theme } from "constants/Theme";

export const ValidationView = () => {

  return (
    // @ts-ignore
    <ThemeProvider theme={theme}>
      <ValidationContainer />
    </ThemeProvider>
  );
};
export default ValidationView;